var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "consultCardRef",
    staticClass: "consult-card"
  }, [_c('div', {
    staticClass: "consult-content"
  }, [_c('div', {
    staticClass: "tel-left"
  }), _c('div', {
    staticClass: "consult-swiper",
    on: {
      "click": _vm.goTel
    }
  }, [_c('div', {
    ref: "swiper",
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.consultsList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_vm._v(_vm._s(item))]);
  }), 0)]), _c('div', {
    staticClass: "right-icon"
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };